import { render, staticRenderFns } from "./AmazeSubnav.vue?vue&type=template&id=0a81cc8b&scoped=true"
import script from "./AmazeSubnav.vue?vue&type=script&lang=js"
export * from "./AmazeSubnav.vue?vue&type=script&lang=js"
import style0 from "./AmazeSubnav.vue?vue&type=style&index=0&id=0a81cc8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81cc8b",
  null
  
)

export default component.exports